import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';

export const FeatureFlagGuardFn: CanActivateFn = (route) => {
  const _featureFlagService = inject(FeatureFlagService);
  try {
    const featureFlag = route.data['FeatureFlag'];
    const result = _featureFlagService.featureOn(featureFlag);

    return result;
  } catch {
    return false;
  }
};
